import { useCustom, useTranslate } from '@refinedev/core';
import { useState } from 'react';
import { IUser } from '../interfaces/user.interface';

interface IUseUserResult {
    user: IUser | undefined;
    token: string | undefined;
    refreshToken: string | undefined;
    isLoading: boolean;
    error: any;
    handleIframeLoad: () => void;
}

export const useUser = (): IUseUserResult => {
    const t = useTranslate();
    const {
        data,
        isLoading: isDataLoading,
        error,
    } = useCustom<IUser[]>({
        url: `api/auth/user`,
        method: 'get',
        errorNotification: (e: any) => ({
            message: ` ${t('notifications.an_error_occurred')}: ${e?.message}`,
            type: 'error',
        }),
    });

    const user: IUser | undefined = data?.data?.[0];
    const token = user?.pharmasol_token;
    const refreshToken = user?.pharmasol_refresh_token;

    const [isIframeLoading, setIsIframeLoading] = useState<boolean>(true);

    const handleIframeLoad = () => {
        setIsIframeLoading(false);
    };

    return {
        user,
        token,
        refreshToken,
        isLoading: isDataLoading || isIframeLoading,
        error,
        handleIframeLoad,
    };
};
